import Spinner from '../../../components/Spinner';
import useTradePools from '../../../hooks/web3/trade/useTradePools';
import useTokenStats from '../../../hooks/web3/useTokenStats';
import TradingCard from './TradingCard';

const TradingCards = () => {
    const { tradePools, isLoading } = useTradePools();
    useTokenStats();

    return (
        <section id='trading-cards'>
            <div className='container'>
                <h2>Click and trade</h2>
                <div className='cards-container'>
                    {isLoading ? (
                        <Spinner />
                    ) : tradePools && tradePools.length ? (
                        tradePools.map((pool, index) => (
                            <TradingCard pool={pool} key={index} />
                        ))
                    ) : (
                        'We had trouble loading trade pairs...'
                    )}
                </div>
            </div>
        </section>
    );
};

export default TradingCards;
